module.exports = __webpack_public_path__ + "img/how-we-work-banner-3b.b5a6ffda.png";